import { createFileRoute } from '@tanstack/react-router';
import {
  PERMISSION_ONLINE_MAP_TEMPLATES_CUSTOMER,
  PERMISSION_ONLINE_MAP_TEMPLATES_PRIVATE,
  PERMISSION_ONLINE_MAP_TEMPLATES_SYSTEM,
} from '../../Services/PermissionsService';
import { requirePermissions } from '../../router/RouteGuardsService';
import OnlinePanel from '../../components/OnlinePanel';

export const Route = createFileRoute('/_authenticated/online_panel/templates/')({
  beforeLoad: async ({ context }) => {
    await requirePermissions(
      [
        PERMISSION_ONLINE_MAP_TEMPLATES_CUSTOMER,
        PERMISSION_ONLINE_MAP_TEMPLATES_PRIVATE,
        PERMISSION_ONLINE_MAP_TEMPLATES_SYSTEM,
      ],
      ['read'],
      '/unauthorized',
      context
    );

    return {
      ...context,
      documentTitle: {
        segments: ['tab.online-map/templates', 'menu.onlinePanel', 'menu.settings'],
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: OnlinePanelRoute,
});

function OnlinePanelRoute() {
  return <OnlinePanel />;
}
